import { render } from "./Marques.vue?vue&type=template&id=43108423&scoped=true"
import script from "./Marques.vue?vue&type=script&lang=js"
export * from "./Marques.vue?vue&type=script&lang=js"

import "./Marques.vue?vue&type=style&index=0&id=43108423&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43108423"]])

export default __exports__